export enum SelectionType {
  ProductSection = 'productSection',
  BundleProductSection = 'bundleProductSection',
  QuickView = 'quickView',
  CompleteTheLook = 'completeTheLook',
  CartPromo = 'cartPromo',
}
